export default "/kiban/_next/static/images/34_10L_3-4-3-00c0abbd0f85369956aa3a8c9447d291.png";